module.exports = __webpack_public_path__ + "static/media/np.0d20f58b.svg";